import { constants } from './constants';

export const setPspCreds = (pspId) => {
  pspId = parseInt(pspId);
  let psp;
  let credentials;
  if (pspId === constants.PSP_IDS.CREDORAX_US) {
    psp = constants.PSP.US;
  } else if (pspId === constants.PSP_IDS.CREDORAX_UK) {
    psp = constants.PSP.UK;
  } else if (pspId === constants.PSP_IDS.CREDORAX_US_LLC) {
    psp = constants.PSP.US_LLC;
  } else {
    return null;
  }

  if (process.env.REACT_APP_FE_ENV === 'PROD') {
    credentials = { sKey: psp.SK.PROD, mId: psp.MID.PROD, script: psp.SCRIPT.PROD };
  } else {
    credentials = { sKey: psp.SK.SANDBOX, mId: psp.MID.SANDBOX, script: psp.SCRIPT.SANDBOX };
  }
  return credentials;
};
